<template>
    <div class="contractmanagement">
        <div class="header">
            <el-row>
                <el-col :span="8">
                    <label class="headerlabel">合同名称</label>
                    <el-input v-model="param.contractName" placeholder="请输入合同名称" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">客户名称</label>
                    <el-select v-model="param.oppositePrincipal" filterable placeholder="请选择客户" class="autowidth" clearable >
                        <el-option v-for="(item,index) in customDataList" :key="index" :label="item.customName" :value="item.customId"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">创建时间</label>
                    <el-date-picker
                    class="autowidth"
                    clearable
                    v-model="createTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd" 
                    format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row style="margin-top: 20px;">
                <el-col :span="8">
                    <label class="headerlabel">销售人员</label>
                    <el-input v-model="param.signedBy" placeholder="请输入销售姓名" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="8">
                    <label class="headerlabel">合同生效日期</label>
                    <el-date-picker
                    class="autowidth" 
                    clearable
                    type="date"
                    v-model="param.contractEffectiveStartDate"
                    placeholder="选择日期">
                    </el-date-picker>
                    
                </el-col>
                <el-col :span="8">
                    <el-button type="primary" @click="init()">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <div style="margin: 0 0 20px;">
                <el-button type="primary" @click="dialogVisible=true">新增</el-button>
                <!-- <el-button style="margin-left: 20px;" @click="Import">导入</el-button> -->
            </div>
            <el-table
            :data="contractData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%">
                <el-table-column prop="contractCode" label="合同编号" ></el-table-column>
                <el-table-column prop="contractName" label="合同名称"></el-table-column>
                <el-table-column prop="customName" label="客户名称"></el-table-column>
                <el-table-column prop="contractAmount" label="合同金额"></el-table-column>
                <el-table-column prop="received" label="已收"></el-table-column>
                <el-table-column prop="notReceived" label="未收"></el-table-column>
                <el-table-column prop="deptName" label="销售部门"></el-table-column>
                <el-table-column prop="signedBy" label="销售人员"></el-table-column>
                <el-table-column prop="collectionMethod" label="催款方式">
                    <template slot-scope="scope">
                        <div>{{scope.row.collectionMethod?scope.row.collectionMethod:'--'}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="客户电话">
                    <template slot-scope="scope">
                        <div>{{scope.row.customerPhone?scope.row.customerPhone:'--'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="contractEffectiveStartDate" label="合同生效日期">
                    <template slot-scope="scope">
                        <div>{{scope.row.contractEffectiveStartDate+'至'+scope.row.contractEffectiveEndDate}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="Edit(scope.row)">修改</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.contractId)">
                            <el-button type="text" style="color: #F24B4E;margin-left: 10px;" slot="reference">删除</el-button>
                        </el-popconfirm>
                        <el-button v-if="scope.row.notReceived>0" type="text" @click="PressForMoney(scope.row)">催款</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <!-- 详情 -->
        <el-dialog
            title="新增合同"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
            <div class="dialogcontent">
                <el-form style="padding: 0 40px;" label-width="80px">
                    <el-form-item label="销售人员">
                        <el-input type="text" v-model="AddParams.signedBy" maxlength="30" placeholder="请输入合同创建人"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="合同编号">
                        <el-input type="text" v-model="AddParams.contractCode" maxlength="30" placeholder="请输入合同编号"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="合同名称">
                        <el-input type="text" v-model="AddParams.contractName" maxlength="100" placeholder="请输入合同名称"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-autocomplete
                            style="width: 240px;"
                            v-model="AddParams.customName"
                            :fetch-suggestions="querySearchAsync"
                            placeholder="请输入内容"
                            @select="handleSelect"
                            >
                            <template slot-scope="{ item }">
                                <div>{{ item.customName}}</div>
                            </template>
                        </el-autocomplete>
                    </el-form-item>
                    <el-form-item label="客户电话">
                        <el-input type="text" v-model="AddParams.customerPhone" maxlength="11" show-word-limit placeholder="请输入电话号码" class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="合同金额">
                        <el-input type="number" v-model="AddParams.contractAmount" placeholder="请输入合同金额" class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="已收金额">
                        <el-input type="number" v-model="AddParams.received" placeholder="请输入已收金额" class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="未收金额">
                        <el-input type="number" v-model="AddParams.notReceived" disabled placeholder="请输入未收金额" class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="销售部门">
                        <el-cascader
                        class="autowidth"
                        ref="tree"
                        :options="SalesDepartment"
                        @change="Selected_to_shut_dow" 
                        @expand-change="bumen"
                        :show-all-levels="false"
                        :props="{ checkStrictly: true }"
                        clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="生效时间">
                        <el-date-picker
                        class="autowidth"
                        clearable
                        v-model="assertTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div style="text-align: right;margin-right: 40px;">
                    <el-button  @click="handleClose">关闭</el-button>
                    <el-button type="primary" @click="Addcovenant()">保存</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- 催款跟进 -->
        <el-dialog 
        title="新增合同"
        :visible.sync="dialogPressForMoney"
        width="480px"
        center
        :before-close="handlePressForMoneyClose">
            <div>
                <el-form label-width="100px">
                    <el-form-item label="单位名称">
                        <el-input v-model="PressForMoneyParms.customName" disabled class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="项目金额">
                        <el-input v-model="PressForMoneyParms.contractAmount" disabled class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="当前回款">
                        <el-input type="number" v-model="PressForMoneyParms.received" class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="剩余回款">
                        <el-input type="number" v-model="PressForMoneyParms.notReceived" disabled class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="催款方式">
                        <el-select v-model="PressForMoneyParms.collectionMethod" placeholder="请选择" class="autowidth" clearable>
                            <el-option label="电话" value="0"></el-option>
                            <el-option label="上门回访" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align: center;margin-left: -100px;">
                        <el-button plain @click="handlePressForMoneyClose">取消</el-button>
                        <el-button type="primary" plain @click="pressformoneysave">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:true,
            dialogVisible:false,
            assertTime:[],
            createTime:[],
            isEdit:false,
            customItem:'',
            customDataList:'',
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                contractName:'',//合同名
                oppositePrincipal:'',//公司主体
                contractEffectiveStartDate:'',//合同生效日期开始时间
                contractEffectiveEndDate:'',//合同生效日期截止时间
                signedBy:'',//创建人
                customName:'',
                params:{//创建时间
                    startSignedDate:'',
                    endSignedDate:''
                }
            },
            customparams:{
                pageNum:1,
                pageSize:10,
                customArea: "",
                customName:''
            },
            AddParams:{
                customId:'',
                contractCode: "",
                contractName: "",
                customerPhone:"",
                companyPrincipal: "",
                customName:'',
                oppositePrincipal: "",
                contractEffectiveStartDate: "",
                contractEffectiveEndDate: "",
                signedBy: "",
                deptId: 1,
                deptName: "",
                contractAmount:'',//合同金额
                received:'',//已收金额
                notReceived:'',//未收金额
            },
            // 催款
            PressForMoneyParms:{
                contractId:'',
                customerPhone:'',
                collectionMethod:'',
                customName:'',
                contractAmount:'',
                received:'',
                notReceived:''
            },
            dialogPressForMoney:false,
            contractData:[],
            SalesDepartment:[],//销售部门
        }
    },
    watch:{
        createTime(newval){
            if(newval==null){
                this.param.params.startSignedDate='';
                this.param.params.endSignedDate='';
            }else{
                this.param.params.startSignedDate=newval[0];
                this.param.params.endSignedDate=newval[1];
            }
        },
        assertTime(newval){//生效时间
            if(newval==null){
                this.AddParams.contractEffectiveStartDate='';
                this.AddParams.contractEffectiveEndDate='';
            }else{
                this.AddParams.contractEffectiveStartDate=newval[0];
                this.AddParams.contractEffectiveEndDate=newval[1];
            }
        },
        'AddParams.contractAmount'(newval,oldval){
            if(parseInt(newval)<0){
                this.AddParams.contractAmount=0;
            }else if(parseInt(this.AddParams.contractAmount)<parseInt(this.AddParams.received)){
                this.AddParams.received=this.AddParams.contractAmount;
            }
            this.AddParams.notReceived=this.AddParams.contractAmount-this.AddParams.received;
        },
        'AddParams.received'(newval,oldval){
            if(parseInt(this.AddParams.contractAmount)<parseInt(newval)){
                this.AddParams.received=this.AddParams.contractAmount;
            }else if(parseInt(newval)<0){
                this.AddParams.received=0;
            }else{
                this.AddParams.notReceived=this.AddParams.contractAmount-this.AddParams.received;
            }
        },
        'PressForMoneyParms.received'(newval,oldval){
            let notReceived=this.PressForMoneyParms.contractAmount-newval;
            if(parseInt(this.PressForMoneyParms.contractAmount)<=parseInt(newval)){
                this.PressForMoneyParms.received=this.PressForMoneyParms.contractAmount;
            }else if(parseInt(newval)<0){
                this.PressForMoneyParms.received=0
            }
            this.PressForMoneyParms.notReceived=notReceived;
        },
        'PressForMoneyParms.contractAmount'(newval,oldval){
            if(parseInt(newval)<0){
                this.PressForMoneyParms.contractAmount=0
            }
        }
    },
    created(){
        this.GetDeprtMentByNode();
        this.customlist();
    },
    mounted() {
        this.init();
    },
    methods: {
        // 获取客户列表
        customlist(){
            this.$Http_Post('/kg/custom/list',this.customparams).then(res=>{
                if(res.Code==0){
                    this.customDataList=res.Data;
                }else{
                    this.$message.error("客户列表获取失败");
                }
            })
        },
        // 获取部门
        GetDeprtMentByNode(){
            this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
                if (res.Code == 200 || res.Code == 0 && res.Data) {
                    this.SalesDepartment = res.Data;
                }
            })
        },
        bumen(dt) {
            let obj = this.SalesDepartment[0];
            for (let i = 0; i < this.SalesDepartment.length; i++) {
                if (this.SalesDepartment[i].DeptID == dt[dt.length - 1]) {
                obj = this.SalesDepartment[i];
                break
                } else if (this.SalesDepartment[i].fuzi && this.SalesDepartment[i].children.length > 0 && this.SalesDepartment[i].children[0].DeptID != '-1') {
                obj = this.GetNodeByDeptID(
                    dt[dt.length - 1],
                    this.SalesDepartment[i].children,
                    )
                }
            }
            let _this = this;
            if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
                obj.children = [{ label: '数据加载中...' }]
                this.$Http_Post('/DepartMent/getalldepartmentbynode', {DeptID: dt[dt.length - 1],content: '',}).then((res) => {
                if (res.Code == 200 || res.Code == 0 && res.Data) {
                    obj.children = res.Data;
                }
                })
            }
        },
        GetNodeByDeptID(ID, NodeList) {
            let obj = null;
            for (let i = 0; i < NodeList.length; i++) {
                if (NodeList[i].DeptID == ID) {
                obj = NodeList[i];
                break
                } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
                obj = this.GetNodeByDeptID(ID, NodeList[i].children);
                if (obj != null) break;
                }
            }
            return obj;
        },
        Selected_to_shut_dow(e){
            let data=this.$refs.tree.getCheckedNodes()
            this.AddParams.deptId=data[0].value;
            this.AddParams.deptName=data[0].label;
        },
        init(){
            this.loading=true;
            this.$Http_Post('/kg/contract/list',this.param).then(res=>{
                if(res.Code==0){
                    this.contractData=res.Data;
                    this.param.PageTotal=res.Counts;
                }else{
                    this.$message.error(res.Message);
                }
                this.loading=false;
            });
        },
        Addcovenant(){
            let Url=this.isEdit?'/kg/contract/edit':'/kg/contract/add'
            this.$Http_Post(Url,this.AddParams).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.dialogVisible=false;
                    this.AddParams=this.$options.data().AddParams;
                    this.param.pageNum=1;
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
                this.isEdit=false;
            });
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
            this.assertTime=[];
            this.AddParams=this.$options.data().AddParams;
            this.param.pageNum=1;
            this.init();
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        Edit(e){
            this.dialogVisible=true;
            // this.AddParams=e;
            this.AddParams={
                contractCode:e.contractCode,
                contractName:e.contractName,
                customerPhone:e.customerPhone,
                companyPrincipal:e.companyPrincipal,
                customName:e.customName,
                oppositePrincipal:e.oppositePrincipal,
                contractEffectiveStartDate:e.contractEffectiveStartDate,
                contractEffectiveEndDate:e.contractEffectiveEndDate,
                signedBy: e.signedBy,
                deptId: 1,
                deptName:e.deptName,
                contractAmount:e.contractAmount,//合同金额
                received:e.received,//已收金额
                notReceived:e.notReceived,//未收金额
            },
            this.AddParams['contractId']=e.contractId
            this.assertTime=[e.contractEffectiveStartDate,e.contractEffectiveEndDate]
            this.isEdit=true;
        },
        // 删除记录
        confirm(id){
            this.$Http_Post('/kg/contract/remove/'+id).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.param.pageNum=1;
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        // 获取客户列表
        querySearchAsync(queryString, cb) {
            this.customlist();
            var restaurants = this.customDataList;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                cb(results);
            }, 3000 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
                return (state.customName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelect(val){
            this.AddParams.oppositePrincipal=val.customId;
            this.AddParams.customName=val.customName;
            this.AddParams.customerPhone=val.customPhone;
            this.customItem=val;
        },
        // 催款弹窗
        PressForMoney(val){
            this.PressForMoneyParms.contractId=val.contractId;
            this.PressForMoneyParms.customerPhone=val.customerPhone;
            this.PressForMoneyParms.customName=val.customName;
            this.PressForMoneyParms.contractAmount=val.contractAmount;
            this.PressForMoneyParms.received=val.received;
            this.PressForMoneyParms.notReceived=val.notReceived;
            this.PressForMoneyParms.collectionMethod=val.collectionMethod;
            this.dialogPressForMoney=true;
        },

        handlePressForMoneyClose(){
            this.dialogPressForMoney=false;
        },
        pressformoneysave(){
            this.$Http_Post('/kg/contract/PressForMoney',this.PressForMoneyParms).then(res=>{
                if(res.Code==0|| res.Code==200){
                    this.$message.success(res.Message);
                    this.dialogPressForMoney=false;
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
    },
}
</script>
<style>
.contractmanagement .header{background: #fff;padding:20px 20px 20px;}
.contractmanagement .header .headerlabel{width:90px;display: inline-block;}
.contractmanagement .autowidth{width: 240px;}
.contractmanagement .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
</style>